import { appLog } from '~src/utils/log';

/** Trigger a file download from S3 storage url */
export const saveFromLink = (link: string, filename = 'download') => {
  appLog(`saveFromLink -> downloading "${filename}"...`);
  // create anchor element
  const anchor = document.createElement('a');
  // add attributes
  anchor.href = link;
  anchor.download = filename;
  // trigger click
  anchor.click();
};
